export const SIGN_IN = "SIGN_IN";
export const SIGN_UP = "SIGN_UP";
export const GOOGLE_AUTH = "GOOGLE_AUTH";
export const SIGN_OUT = "SIGN_OUT";

